import React from 'react';
import SetupAccountsStep from 'components/AccountConnectionFlow/SetupAccountsStep';

const SetUpMetaAccountsStep = (props) => {
  return <SetupAccountsStep />;
};

export default SetUpMetaAccountsStep;
